// 导入任务，轮询
import { latentImportErrorListApi } from "@/api/taskCenter";
import { Message } from "element-ui";
export function importLoop(tid: number, cd: number = 2000) {
  let count: number = 0;
  return new Promise((resolve, reject) => {
    // 开启一个定时器，只有上个任务成功了之后，再执行下一个任务
    const loopCd: any = setInterval(() => {
      count = count + 1;
      if (count > 30) {
        Message({
          showClose: true,
          message: "导入失败",
          type: "error",
        });
        clearInterval(loopCd);
        reject();
      }
      latentImportErrorListApi({ task_id: tid })
        .then((taskRes: any) => {
          if (taskRes.error_code === 0) {
            count = 0;
            clearInterval(loopCd);
            resolve(taskRes);
          } else {
            Message({
              showClose: true,
              message: taskRes.message,
              type: "warning",
            });
            clearInterval(loopCd);
            reject();
          }
        })
        .catch(() => {
          Message({
            showClose: true,
            message: "导入失败",
            type: "error",
          });
          clearInterval(loopCd);
          reject();
        });
    }, cd);
  });
}
